import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController, LoadingController } from '@ionic/angular/lazy';
import { APIService } from 'src/app/services/api.service';
import * as bcrypt from 'bcryptjs';

@Component({
    selector: 'app-user-pin-change',
    templateUrl: './user-pin-change.page.html',
    styleUrls: ['./user-pin-change.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserPINChangePage implements OnInit {

    spinner = null;
    @Input() user = null;
    current_pin = '';
    new_pin = '';

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private loadingController: LoadingController,
        private apiService: APIService
    ) { }

    ngOnInit() {
    }

    close() {
        this.modalController.dismiss();
    }

    update() {
        this.current_pin = this.current_pin.trim();
        if(!this.current_pin.length) {
            this.presentAlert('Missing Current PIN', 'Please enter your current PIN.');
            return;
        }
        this.new_pin = this.new_pin.replace(/\D/g, '');
        if(this.new_pin.length < 4) {
            this.presentAlert('Invalid New PIN', 'The New PIN needs to be at least 4 numbers. Please try again.');
            return;
        }
        this.presentSpinner("Validating Current PIN").then(() => {
            bcrypt.compare(this.current_pin, this.user.pin_hash, (error, is_match) => {
                if(!error) {
                    if(is_match) {
                        this.spinner.message = "Updating PIN";
                        this.apiService.updateUser(this.user.id, { pin: this.new_pin }).then((user) => {
                            this.spinner.dismiss();
                            this.modalController.dismiss();
                        })
                        .catch((error) => {
                            if(error.status == 400) {
                                this.presentAlert('Unknown error', 'Unfortunately something went wrong when trying to update your PIN.');
                            } 
                            else if(error.status == 403) {
                                this.presentAlert('Insufficient permissions', 'You don\'t have permission to update your PIN.');
                            } 
                            else if(error.status == 404) {
                                this.presentAlert('Unavailable', 'Unfortunately we\'re unable to update your PIN at this time.');
                            }
                            else if(error.status == 0) {
                                this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                            }
                            this.spinner.dismiss();
                        });
                        
                    } 
                    else {
                        this.spinner.dismiss();
                        this.presentAlert('Invalid Current PIN', 'The Current PIN is incorrect. Please try again.');
                    }
                }
                else {
                    this.spinner.dismiss();
                    console.log(error);
                }
            });
        })
        .catch(() => {
            this.spinner.dismiss();
        });
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}
